import { Fragment } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import { styled, useTheme } from "@mui/material/styles";

const MaskImg = styled("img")(() => ({
  zIndex: -1,
  bottom: "7%",
  width: "100%",
  position: "absolute"
}));

const FooterIllustrations = (props) => {
  const { image } = props;

  const theme = useTheme();

  const hidden = useMediaQuery(theme.breakpoints.down("md"));
  const src =
    image || `/images/pages/auth-v1-login-mask-${theme.palette.mode}.png`;
  if (!hidden) {
    return (
      <Fragment>
        <MaskImg alt="mask" src={src} />
      </Fragment>
    );
  } else {
    return null;
  }
};

export default FooterIllustrations;
